<mat-icon class="date" [class]="target ? 'target' : 'actual'">
  {{ target ? "flare" : "check_circle" }}
</mat-icon>
